import { MultiFieldDynamicFields } from '../multiFieldDynamicFields';
import { FormikProps } from 'formik';
import { MultiDynamicField } from '../../../../../shared/types/assistant';

export const DomainAreas = ({
    formikDomainAreas,
}: {
    formikDomainAreas: FormikProps<{ [key: string]: MultiDynamicField[] }>;
}) => {
    return (
        <MultiFieldDynamicFields
            formik={formikDomainAreas}
            name="domainAreas"
            label="Áreas de dominio"
            description="Establece los temas y ámbitos en los que tu asistente virtual tiene conocimiento y puede brindar soporte, asegurando que las respuestas sean precisas, actualizadas y alineadas con las necesidades del usuario, incluyendo Categorías, Subcategorías y Alcance de Información."
            example={{
                title: 'Trámites y Certificaciones',
                description: 'Estado de cuenta, constancias, renovaciones.',
            }}
        />
    );
};
